export default "__VITE_ASSET__BShGhuI1__"